import { INoticeInfoData } from "./notice.types";

export class NoticeInfo implements INoticeInfoData {
  readonly id: string;
  readonly category: string;
  readonly title: string;
  readonly content: string;
  readonly createdDate: string;
  readonly lastModifiedDate: string;
  readonly isShow: boolean;
  readonly isPopup: boolean;
  readonly campusCodeUid?: string;
  readonly campusName?: string;
  readonly altText?: string;
  wasRead: boolean;

  constructor(data: INoticeInfoData) {
    this.id = data.id;
    this.category = data.category;
    this.title = data.title;
    this.content = data.content;
    this.createdDate = data.createdDate;
    this.lastModifiedDate = data.lastModifiedDate;
    this.isShow = data.isShow;
    this.isPopup = data.isPopup;
    this.campusCodeUid = data.campusCodeUid;
    this.campusName = data.campusName;
    this.altText = data.altText;
    this.wasRead = data.wasRead;
  }
}
